import { FC } from "react";
import styles from "./styles.module.scss";
import { Props } from "./typings";
import NotesDesk from "components/NotesDesk";

const CaseNotes: FC<Props> = ({ caseId }) => {
  return (
    <div className={styles.wrapper}>
      <NotesDesk showHeader={false} caseId={caseId}></NotesDesk>
    </div>
  );
};

export default CaseNotes;
